<app-text [alias]="'email_class_component'"></app-text>
<mat-tab-group>
    <mat-tab label="Compose">
        <app-text [alias]="'email_class_component_compose_tab'"></app-text>
        <app-loading-wrapper [loading]="saving || !formGroup">
            <form *ngIf="questions" [formGroup]="formGroup">
                <app-question [question]="questions.toEmails"></app-question>
                <app-question [question]="questions.ccEmails"></app-question>
                <app-question [question]="questions.subject"></app-question>
                <app-question [question]="questions.body"></app-question>
                <app-button-list>
                    <app-button [disabled]="formGroup.invalid" [loading]="saving" (clickedEvent)="sendEmail()">Send Email </app-button>
                </app-button-list>
            </form>
        </app-loading-wrapper>
    </mat-tab>
    <mat-tab label="Past Emails">
        <app-text [alias]="'email_class_component_past_emails_tab'"></app-text>
        <ng-template matTabContent>
            <app-email-card-view *ngIf="course" [alias]="'igrade'" [id]="course.id"></app-email-card-view>
        </ng-template>
    </mat-tab>
</mat-tab-group>